import { createSelector } from "@reduxjs/toolkit";
import { RootState } from ".";
import { CommonReducerType } from "./reducers";

const commonlReducer = (state: RootState) => state.common;

export const loader = (key?: string) => {
	return createSelector(commonlReducer, (state: CommonReducerType): boolean => {
		if (key) {
			return state.loader[key] > 0;
		} else {
			return state.generalLoader > 0;
		}
	});
};

export const commonIsInitSelector = createSelector(
	commonlReducer,
	(state) => state.isInit
);

export const commonProvinceSelector = createSelector(
	commonlReducer,
	(state) => state.province
);

export const commonComuniSelector = createSelector(
	commonlReducer,
	(state) => state.comuni
);
